import { ArrowUpRight } from "lucide-react";
import { PORTFOLIO } from "../../lib/data";
import { Reveal, Overline } from "../Reveal";

const Card = ({ item, index, testid }) => {
  const tall = index % 2 === 0;
  return (
    <div data-testid={testid} className={`group ${tall ? "md:mt-0" : "md:mt-24"}`}>
      <div className="relative overflow-hidden rounded-2xl aspect-[4/5] bg-[#0d0d0d]">
        <img src={item.img} alt={item.title} className="absolute inset-0 w-full h-full object-contain object-center" />
        <div className="absolute inset-0 pointer-events-none opacity-0 group-hover:opacity-100 transition-opacity duration-500" style={{ background: "linear-gradient(180deg, transparent 55%, rgba(5,5,5,0.85))" }} />
        <div className="absolute top-5 right-5 h-11 w-11 rounded-full glass-dark flex items-center justify-center opacity-0 -translate-y-2 group-hover:opacity-100 group-hover:translate-y-0 transition-all duration-500 text-white">
          <ArrowUpRight size={18} />
        </div>
      </div>
      <div className="flex items-baseline justify-between mt-5">
        <div>
          <h3 className="text-2xl font-semibold tracking-tight">{item.title}</h3>
          <p className="text-sm text-white/50 mt-1">{item.desc}</p>
        </div>
        <span className="text-xs uppercase tracking-[0.16em] shrink-0 ml-4" style={{ color: "var(--gold)" }}>{item.tag}</span>
      </div>
    </div>
  );
};

export const PortfolioSection = ({ heading = true }) => (
  <section className="bg-[#050505] text-white py-24 md:py-32 px-6" data-testid="portfolio-section">
    <div className="max-w-7xl mx-auto">
      {heading && (
        <div className="max-w-3xl mb-16">
          <Reveal><Overline dark>Przykłady</Overline></Reveal>
          <Reveal delay={0.05}>
            <h2 className="text-4xl sm:text-5xl lg:text-6xl tracking-tightest leading-[1.02] font-semibold">
              Projekty <span className="font-serif-italic font-normal" style={{ color: "var(--gold)" }}>demonstracyjne.</span>
            </h2>
          </Reveal>
          <Reveal delay={0.1}>
            <p className="mt-6 text-lg text-white/55 max-w-xl">
              Przykładowe rozwiązania pokazujące, jak nowoczesna strona, AI i automatyzacja mogą wspierać różne rodzaje firm.
            </p>
          </Reveal>
        </div>
      )}
      <div className="grid grid-cols-1 md:grid-cols-2 gap-8 md:gap-12">
        {PORTFOLIO.map((item, i) => (
          <Card key={item.title} item={item} index={i} testid={`portfolio-item-${i}`} />
        ))}
      </div>
    </div>
  </section>
);
